import { render, staticRenderFns } from "./LikeButton.vue?vue&type=template&id=4820750e&scoped=true"
import script from "./LikeButton.vue?vue&type=script&lang=js"
export * from "./LikeButton.vue?vue&type=script&lang=js"
import style0 from "./LikeButton.vue?vue&type=style&index=0&id=4820750e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4820750e",
  null
  
)

export default component.exports